/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { AbilityModel, SearchModel } from '../../../models/AbilityModel'
import * as AbilitiesCRUD from '../../abilities/AbilitiesCRUD';
import { ABILITIES_TYPES, LIST_PERMISSIONS, RECIEPT_VOUCHER } from '../../../constants/common';
import Flatpickr from "react-flatpickr";
import moment from 'moment';
import PaymentVoucherTable from '../../abilities/agency/PaymentVoucherTable';
import { PaginateModel } from '../../../models/PaginateModel';
import { HeaderModel, ModalModel } from '../../../models/CommonModel';
import { useIntl } from 'react-intl';
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import { Confirm, download, Toast } from '../../../modules/common/helper';
import { openNewTabWithHtml } from '../../../selectors';
import ReceiptVoucherTable from '../../abilities/receipt-voucher/ReceiptVoucherTable';
import { usePermissionChecker } from '../../../hooks/PermissionChecker';

type Props = {
    show: boolean
    data?: any
    mode: string
    handleEditItem: (item: AbilityModel) => void
    onClose: () => void
}
const AgencyDebtModal: React.FC<Props> = ({ show, data, onClose, handleEditItem }) => {
    const intl = useIntl();
    const { hasPermission } = usePermissionChecker();
    const type: any = ABILITIES_TYPES.find((e) => {
        return e.label == RECIEPT_VOUCHER
    });
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<AbilityModel>>();
    const [hideCols, setHideCols] = useState<string[]>([]);
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const initSearch = {
        type: type?.id,
        per_page: 1000000
    }
    const fp = useRef<any>(null);
    const [search, setSearch] = useState<SearchModel>(initSearch)
    useEffect(() => {
        if (show && data?.agency?.id) {
            getData({...search, agency_id: data?.agency?.id});
        }
    }, [show, data]);

    const getData = async (params?: SearchModel) => {
        const { data: resData } = await AbilitiesCRUD.getList({...params, agency_id: data?.agency?.id});
        setDataPaginate(resData?.paginate_data);
        setSearch(params ?? {});
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getData({ ...search, page: 1 })
    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        setSearch(initSearch);
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        getData(initSearch)
    }
    const handleExportPdf = async (id: number) => {
        const {data: resData} = await AbilitiesCRUD.exportPdf({id: id, type: type?.id})
        openNewTabWithHtml(resData);
        //download(resData, 'phieu-thu-'+id, 'pdf')
    }
    
    const header: HeaderModel[] = [
        {
            label: 'Mã số phiếu',
            style: { minWidth: "100px" },
            field: 'id',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.DATE' }),
            style: { minWidth: "150px" },
            field: 'created_at',
            sortable: true
        },
        {
            label: 'Ngày sao kê',
            style: { minWidth: "150px" },
            field: 'date',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.PAYER' }),
            style: { minWidth: "150px" },
            field: 'name',
            sortable: true
        },
        {
            label: 'Ngân hàng',
            style:  { minWidth: "150px" },
            field: 'bank_id',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.DESCRIPTION' }),
            style: { minWidth: "150px" },
            field: 'note',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.RECEIVE_AMOUNT' }),
            style: { minWidth: "150px" },
            field: 'value',
            sortable: true
        },
        {
            label: 'Loại chi phí',
            style: { minWidth: "120px" },
            field: 'expense_group',
            sortable: false
        },
        {
            label: 'Phương thức thanh toán',
            style: { minWidth: "120px" },
            field: 'payment_method',
            sortable: true
        },
        // {
        //     label: 'Tài liệu',
        //     style: { minWidth: "120px" },
        //     field: 'doc_label',
        //     sortable: false
        // }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    const handleCheck = (e: any, item: AbilityModel) => {
        let newCheckedIds = [...selectedIds];
        if (e.target.checked) {
            newCheckedIds.push(item.id)
        } else {
            newCheckedIds = newCheckedIds.filter((id) => id !== item.id)
        }

        setSelectedIds([...newCheckedIds])
    }

    const handleCheckAll = (e: any) => {
        let newCheckedIds = [...selectedIds];
        let ids: number[] = dataPaginate?.data?.map((item: AbilityModel) => item.id) ?? [];
        if (e.target?.checked) {
            newCheckedIds.concat(ids);
        } else {
            newCheckedIds.filter((id) => !ids.includes(id))
        }
        setSelectedIds([...newCheckedIds])
    }

    const handleDelete = async () => {
        Confirm.fire({
            icon: 'question',
            title: intl.formatMessage({ id: 'COMMON.CONFIRM_DELETE' }, { name: 'các đơn dữ liệu đã chọn' }),
            confirmButtonText: intl.formatMessage({ id: 'COMMON.YES' }),
            cancelButtonText: intl.formatMessage({ id: 'COMMON.NO' }),
        }).then(async (res) => {
            if (res.isConfirmed) {
                try {
                    const res = await AbilitiesCRUD.remove(selectedIds);
                    Toast.fire({
                        icon: 'success',
                        title: res?.data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
                    })
                    setSelectedIds([])
                } finally {
                    getData({ ...search, page: 1 })
                }
            }
            
        })
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
            size='xl'
        >
            <Modal.Header className='d-flex p-3'>
                <Modal.Title>{ data?.agency?.name }</Modal.Title>
            </Modal.Header>
            <Modal.Body className=" p-3">
                <div className="card">
                    <div className="card-header p-0 pb-3">
                        <div className="col-md-12">
                            <form onSubmit={handleSearch}>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="form-label">Từ khóa</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            name="keyword"
                                            value={search.keyword || ''}
                                            onChange={(e) => setSearch({ ...search, keyword: e.target.value })}
                                            autoComplete='nope'
                                        />
                                    </div>
                                    <div className='col-md-3 mb-2'>
                                        <label className="form-label">Từ ngày</label>
                                        <Flatpickr
                                            options={{
                                                dateFormat: "d-m-Y",
                                                locale: Vietnamese,
                                                shorthandCurrentMonth: true
                                            }}
                                            onChange={(date) => {
                                                let startDate = moment(date[0]).format('YYYY-MM-DD');
                                                let sDate = search.date ?? {startDate: "", endDate: ""};
                                                sDate.startDate  = startDate;
                                                setSearch({ ...search, date: sDate });
                                            }}
                                            className='form-control'
                                            placeholder=''
                                        />
                                    </div>
                                    <div className='col-md-3 mb-2'>
                                        <label className="form-label">Tới ngày</label>
                                        <Flatpickr
                                            options={{
                                                dateFormat: "d-m-Y",
                                                locale: Vietnamese,
                                                shorthandCurrentMonth: true
                                            }}
                                            onChange={(date) => {
                                                let endDate = moment(date[0]).format('YYYY-MM-DD');
                                                let sDate = search.date ?? {startDate: "", endDate: ""};
                                                sDate.endDate  = endDate;
                                                setSearch({ ...search, date: sDate });
                                            }}
                                            className='form-control'
                                            placeholder=''
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <div className="btns-group">
                                            <button
                                                className="col-auto btn btn-primary mt-8 me-2"
                                                onClick={handleSearch}
                                            >
                                                <i className="bi bi bi-search fs-4"></i>
                                            </button>
                                            <button
                                                className="col-auto btn btn-danger mt-8 me-2"
                                                type="button"
                                                onClick={handleClearSearch}
                                            >
                                                <i className="bi bi-eraser-fill fs-1"></i>
                                            </button>
                                            {(hasPermission(LIST_PERMISSIONS.ABILITIES_DELETE) && selectedIds?.length > 0) && (
                                                <button
                                                    className="col-auto btn btn-danger mt-8 me-2"
                                                    type="button"
                                                    onClick={handleDelete}
                                                >
                                                    {intl.formatMessage({id: 'COMMON.DELETE'})}
                                                </button>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <ReceiptVoucherTable
                            data={dataPaginate?.data || []}
                            handleExportPdf={handleExportPdf}
                            openColConfig={() => setConfigModal({ ...configModal, show: true })}
                            header={header}
                            hideCols={hideCols}
                            handleSort={handleSort}
                            hideConfig={true}
                            handleEditItem={handleEditItem}
                            handleCheck={handleCheck}
                            selectedIds={selectedIds}
                            handleCheckAll={handleCheckAll}
                            canEdit={hasPermission(LIST_PERMISSIONS.ABILITIES_EDIT)}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AgencyDebtModal
